import script from "./barterIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./barterIndex.vue?vue&type=script&setup=true&lang=js"

import "./barterIndex.vue?vue&type=style&index=0&id=0d8bd1c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8bd1c3"]])

export default __exports__